import { render, staticRenderFns } from "./AssignRelationManager.vue?vue&type=template&id=b57d99dc"
import script from "./AssignRelationManager.vue?vue&type=script&lang=js"
export * from "./AssignRelationManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports